import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import { styled, useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import MenuItems from "../components/Layout/MenuItems";
import Navbar from "./Navbar";
import { loadMenus } from "./sideMenu";
import { useDataLayerValue } from "../DataLayer/DataLayer";

const drawerWidth = 270;

// Drawer styles
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer({ children }) {
  const [menuData, setMenuData] = useState([]);
  const [{ drawerOpen }, dispatch] = useDataLayerValue();
  const open = drawerOpen ?? true;

  const theme = useTheme();
  const { direction } = theme;

  const setOpen = useCallback(
    (value) => dispatch({ type: "SET_DRAWER_OPEN", drawerOpen: value }),
    [dispatch]
  );
  const handleDrawerOpen = useCallback(() => setOpen(true), [setOpen]);
  const handleDrawerClose = useCallback(() => setOpen(false), [setOpen]);

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const data = await loadMenus();
        setMenuData(data.sideMenu || []);
        console.log("Menu Data:", data.sideMenu);
      } catch (err) {
        console.error("Failed to load menus:", err);
      }
    };
    fetchMenus();
  }, []);

  const renderedMenuItems = useMemo(
    () =>
      menuData.map((item, index) => (
        <MenuItems
          key={item.id || index}
          setOpen={setOpen}
          main
          route=""
          open={open}
          item={item}
          level={0}
        />
      )),
    [menuData, open]
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        sx={{ background: "white" }}
        color="secondary"
        position="fixed"
        open={open}
      >
        <Navbar handleDrawerOpen={handleDrawerOpen} open={open} />
      </AppBar>

      <Drawer
        variant="permanent"
        PaperProps={{
          sx: { backgroundColor: "black", color: "white" },
        }}
        open={open}
      >
        <DrawerHeader sx={{ borderBottom: "0.5px solid white" }}>
          <img src="/dist/img/logo_sidemenu.png" alt="Logo" />
          <IconButton onClick={handleDrawerClose}>
            {direction === "rtl" ? (
              <ChevronRightIcon sx={{ color: "white" }} />
            ) : (
              <ChevronLeftIcon sx={{ color: "white" }} />
            )}
          </IconButton>
        </DrawerHeader>

        <Divider />
        <List sx={{ padding: "10px" }}>{renderedMenuItems}</List>
      </Drawer>

      <Box component="main" sx={{ flex: 1, overflow: "hidden" }}>
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
}

MiniDrawer.propTypes = {
  children: PropTypes.node,
};


// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import MuiAppBar from "@mui/material/AppBar";
// import Box from "@mui/material/Box";
// import CssBaseline from "@mui/material/CssBaseline";
// import Divider from "@mui/material/Divider";
// import MuiDrawer from "@mui/material/Drawer";
// import IconButton from "@mui/material/IconButton";
// import List from "@mui/material/List";
// import { styled, useTheme } from "@mui/material/styles";
// import PropTypes from "prop-types";
// import * as React from "react";
// import MenuItems from "../components/Layout/MenuItems";
// import Navbar from "./Navbar";
// import { loadMenus, menus } from "./sideMenu";

// const drawerWidth = 270;

// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   // necessary for content to be below app bar
//   ...theme.mixins.toolbar,
// }));

// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));

// export default function MiniDrawer({ children }) {
//   const [menuData, setMenuData] = React.useState([]);

//   const theme = useTheme();
//   const [open, setOpen] = React.useState(true);

//   const handleDrawerOpen = () => {
//     setOpen(true);
//   };

//   React.useEffect(() => {
//     loadMenus().then((data) => console.log(data?.sideMenu, "Menu Data ??"));
//     loadMenus().then((data) => setMenuData(data.sideMenu));
    
//   }, []);
//   const handleDrawerClose = () => {
//     setOpen(false);
//   };


//   console.log(menuData,"Data ??")
//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />
//       <AppBar
//         sx={{ background: "white" }}
//         color="secondary"
//         position="fixed"
//         open={open}
//       >
//         <Navbar handleDrawerOpen={handleDrawerOpen} open={open}></Navbar>
//       </AppBar>

//       <Drawer
//         variant="permanent"
//         PaperProps={{
//           sx: {
//             backgroundColor: "black",
//             color: "white",
//           },
//         }}
//         open={open}
//       >
//         <DrawerHeader sx={{ borderBottom: "0.5px solid white" }}>
//           <img src="/dist/img/logo_sidemenu.png" alt="" />
//           <IconButton onClick={handleDrawerClose}>
//             {theme.direction === "rtl" ? (
//               <ChevronRightIcon sx={{ color: "white" }} />
//             ) : (
//               <ChevronLeftIcon sx={{ color: "white" }} />
//             )}
//           </IconButton>
//         </DrawerHeader>
//         <Divider />
//         <List sx={{ padding: "10px" }}>
//           {menuData.map((item, index) => {
//             return (
//               <MenuItems
//                 key={index + ""}
//                 setOpen={setOpen}
//                 main
//                 route=""
//                 open={open}
//                 item={item}
//                 level={0}
//               />
//             );
//           })}
//         </List>
//       </Drawer>
//       <Box component="main" sx={{ flex: 1, overflow: "hidden" }}>
//         <DrawerHeader />
//         {children}
//       </Box>
//     </Box>
//   );
// }
// MiniDrawer.propTypes = {
//   children: PropTypes.any,
// };


